import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/rustomjee-logo.webp"
          width="150px"
          height="70px"
          loading="lazy"
          alt="logo"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h2 className="d-block section-heading-sub text-capitalize">
            About Developer
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={handleShowModal}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Rustomjee is one of India’s most reputed real estate developers with a
        rich legacy of creating premium living spaces that marry architectural
        brilliance with thoughtful design. With landmark addresses across
        Mumbai, Rustomjee is known for quality, trust, innovation, and
        community-first developments.
        <br />
        Rustomjee Balmoral Golf Links is a rare masterpiece in their portfolio—a
        project that reflects a once-in-a-lifetime opportunity to own a timeless
        address with uninterrupted green views, curated amenities, and serene
        living. Every home is a legacy in the making.
      </p>

      <div className="rera-numbers">
        <div className="rera-item">
          <img src="images/rera-P51800079955.PNG" alt="rera qr" />
          <strong>P51800079955</strong>
        </div>
        <div className="rera-item">
          <img src="images/rera-P51800080027.PNG" alt="rera qr" />
          <strong>P51800080027</strong>
        </div>
      </div>

      <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <p></p>
      <button
        className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
